import { Injectable } from '@angular/core';
import { OpsEvent, OpsEventLight } from '@models/ops-event/ops-event';
import { OpsEventWebservice } from '@webservices/ops-event-api/ops-event.webservice';
import { Observable } from 'rxjs';

@Injectable()
export class OpsEventStoreService {
  private storedOpsEvents$: Observable<OpsEventLight[]>;
  private loaded = false;

  constructor(private readonly opsEventWebservice: OpsEventWebservice) {}

  getAll(): Observable<OpsEventLight[]> {
    if (!this.loaded) {
      this.storedOpsEvents$ = this.opsEventWebservice.getAll();
      this.loaded = true;
    }

    return this.storedOpsEvents$;
  }

  getBy(eventId: string): Observable<OpsEvent> {
    return this.opsEventWebservice.getBy(eventId);
  }
}
